import EditCashbackModal from './EditCashbackModal';

export default EditCashbackModal;
